import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const Footer = () => {
  let year = moment().format("YYYY");

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            <ul className="list-inline">
              <li className="list-inline-item">
                <Link to="/" className="text-muted" href="#">
                  Otochat &copy; {year}
                </Link>
              </li>
              {/* <li className="list-inline-item">
                <a className="text-muted" href="#">
                  Support
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#">
                  Help Center
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#">
                  Privacy
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="#">
                  Terms of Service
                </a>
              </li> */}
            </ul>
          </div>
          <div className="col-6 text-end">
            <p className="mb-0">
              <a
                href="https://otokata.id"
                target="_blank"
                className="text-muted"
              >
                Powered by Otokata
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
